
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 300 351.5"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('g',{attrs:{"data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M225.72 88.4a88.4 88.4 0 10-104.85 86.8h32.91a88.51 88.51 0 0071.94-86.8zM153.78 175.2l-16.46 68.87-16.45-68.87C52.89 183.36 0 241.35 0 311.5h274.65c0-70.15-52.89-128.14-120.87-136.3z"}})])])])
          )
        }
      }
    